export interface I18nLabel {
  labelJp: string;
}

export function translate(label: I18nLabel, locale: string) {
  return locale === 'ja' ? label.labelJp : label.labelJp;
}
